<template>
  <div class="py-2">
    <label :for="label" class="block text-sm font-medium text-gray-700">
      {{ label }}
    </label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{ description }}
    </div>
    <Combobox v-model="selected">
      <div class="relative">
        <div class="relative">
          <!-- Adiciona o botão X se houver uma seleção -->
          <ComboboxInput @focus="openDropdown"
            class="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-500 sm:text-xss"
            :displayValue="(item) => item?.name" @change="searchTo" />

          <!-- Botão para remover a seleção -->
          <ComboboxButton v-if="selected" @click="unSelected()"
            class="absolute inset-y-0 right-8 flex items-center pr-2">
            <XMarkIcon class="h-4 w-4 text-gray-500 hover:text-red-500 cursor-pointer" />
          </ComboboxButton>

          <!-- Botão de navegação (seta para baixo) -->
          <ComboboxButton class="absolute inset-y-0 right-0 flex items-center pr-2">
            <ArrowsUpDownIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </ComboboxButton>
        </div>

        <TransitionRoot leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0"
          @after-leave="query = ''">
          <ComboboxOptions
            class="z-10 absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-xss shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-xss">
            <div v-if="filteredDataRows.length === 0 && query !== ''"
              class="relative cursor-default select-none py-2 px-4 text-gray-700">
              Not found
            </div>
            <ComboboxOption v-for="item in filteredDataRows" as="template" :key="item.id" :value="item"
              v-slot="{ selected, active }">
              <li @click="update(item)" class="relative cursor-default select-none py-2 pl-10 pr-4"
                :class="{ 'bg-slate-600 text-white': active, 'text-gray-900': !active }">

                <span class="truncate flex items-center" :class="{ 'font-medium': selected, 'font-normal': !selected }">
                  <!-- Colocar icone de form aqui -->
                  
                  {{ item.name }}
                </span>
                <span v-if="selected" class="absolute inset-y-0 left-0 flex items-center pl-3"
                  :class="{ 'text-white': active, 'text-teal-600': !active }">
                  <CheckIcon class="h-5 w-5" aria-hidden="true" />
                </span>
              </li>
            </ComboboxOption>
          </ComboboxOptions>
        </TransitionRoot>

        <div v-if="error" class="text-red-500 text-xs mt-1">
          {{ error }}
        </div>
      </div>
    </Combobox>
  </div>
</template>

<script>
import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
  TransitionRoot,
} from "@headlessui/vue";

import { CheckIcon, ArrowsUpDownIcon, XMarkIcon } from "@heroicons/vue/24/solid";

export default {
  name: "DropDownSearchFormFields",
  props: {
    label: String,
    description: String,
    agent_id: [String],
    show_user: {
      type: Boolean,
      default: true,
    },
    value: [String, Object, Boolean],
    allMembers: Boolean,

    userOnline: {
      type: Boolean,
      default: false,
    },

    showCalendar: {
      type: Boolean,
      default: false,
    },

    error: String,
  },
  data() {
    return {
      urlMembers: "core/components/fields/forms",
      dataRows: [],
      query: "",
      item: {},
      selected: "",
      params: {
        agent_id: this.agent_id,
      },
    };
  },
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    TransitionRoot,
    CheckIcon,
    ArrowsUpDownIcon,
    XMarkIcon,
  },
  methods: {
    openDropdown() {
      this.$nextTick(() => {
        const comboboxInput = this.$el.querySelector("input");
        if (comboboxInput) {
          comboboxInput.dispatchEvent(
            new KeyboardEvent("keydown", { key: "ArrowDown" })
          );
        }
      });
    },

    getMembers() {
      this.$ApiService.post(this.urlMembers, this.params)
        .then((response) => {
          // Verifica se a resposta contém os dados esperados
          if (response.data && Array.isArray(response.data.rows)) {
            this.dataRows = response.data.rows;

            // Atualiza o item e seleciona, se necessário
            if (this.value) {
              this.item = this.dataRows.find((item) => item.id === this.value) || null;
              this.selected = this.item;
            }
          } else {
            console.warn("A resposta não contém os dados esperados.");
            this.dataRows = [];
          }
        })
        .catch((error) => {
          console.error("Erro ao buscar membros:", error);
        });
    },



    searchTo($event) {
      this.query = $event.target.value;
    },
    unSelected() {
      this.selected = "";
      this.$emit("update:modelValue", null);
    },

    update(item) {
      this.item = item;
      this.$emit("update:modelValue", this.item.id);
    },

    search(item) {
      return (
        (item.name||"").toLowerCase().indexOf((this.query||"").toLowerCase()) > -1
      );
    },
  },

  computed: {
    filteredDataRows() {
      if (this.dataRows === undefined || !this.dataRows.length) {
        return "";
      }
      return this.dataRows.filter((item) => {
        if (this.search(item)) {
          return item.name;
        }
      });
    },
  },

  watch: {
    agent_id(newValue) {
      this.params.agent_id = newValue;
      this.selected = "";
      this.$emit("update:modelValue", null);
      this.getMembers();
    },



  },

  created() {
    this.params.agent_id = this.agent_id;
    setTimeout(() => {
      this.getMembers();
    }, 100);
  },
};
</script>
